import type { FunctionComponent } from "react";
import type { IPagination } from "../../../types/models/pagination.models.types";
import Spinner from "../../../components/spinner.components";
import Button from "./button.core";

interface IProps {
  fetching: boolean;
  paginationData: IPagination;
  onClick: () => void;
}

const PaginationComponent: FunctionComponent<IProps> = ({
  fetching,
  paginationData,
  onClick,
}) => {
  return (
    <div className="flex justify-center items-center">
      {paginationData.page < paginationData.totalPages ? (
        fetching ? (
          <div className="flex justify-center items-start h-10">
            <Spinner width={20} />
          </div>
        ) : (
          <Button
            variant="secondary"
            onClick={onClick}
            className="px-3 py-2 border rounded-lg font-semibold text-xs"
          >
            Load more +
          </Button>
        )
      ) : null}
    </div>
  );
};

export default PaginationComponent;
